import Corner from "./Corner";

// Export without redux connection
export default Corner;
